import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grey-form-card"
}
const _hoisted_2 = { class: "card-parent" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h6", { class: "small-grey" }, "General information", -1)
const _hoisted_4 = { class: "card-row" }
const _hoisted_5 = { class: "card-label" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Site Name:")
const _hoisted_7 = { class: "card-value" }
const _hoisted_8 = { class: "card-row" }
const _hoisted_9 = { class: "card-label" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Country:")
const _hoisted_11 = { class: "card-value" }
const _hoisted_12 = { class: "card-row" }
const _hoisted_13 = { class: "card-label" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Data storage:")
const _hoisted_15 = { class: "card-value" }
const _hoisted_16 = {
  key: 1,
  class: "card-row"
}
const _hoisted_17 = { class: "card-label" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Address:")
const _hoisted_19 = { class: "card-value" }
const _hoisted_20 = {
  key: 2,
  class: "card-row"
}
const _hoisted_21 = { class: "card-label" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Website:")
const _hoisted_23 = { class: "card-value" }
const _hoisted_24 = {
  key: 3,
  class: "card-row"
}
const _hoisted_25 = { class: "card-label" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Comment:")
const _hoisted_27 = { class: "card-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditIcon = _resolveComponent("EditIcon")
  const _component_el_button = _resolveComponent("el-button")
  const _component_CorporateFareIcon = _resolveComponent("CorporateFareIcon")
  const _component_FmdGood = _resolveComponent("FmdGood")
  const _component_CloudDone = _resolveComponent("CloudDone")
  const _component_Computer = _resolveComponent("Computer")
  const _component_Comment = _resolveComponent("Comment")

  return (_ctx.siteProfile)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.hasRole(_ctx.UserRole.SystemAdmin))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "single-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editSite()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EditIcon)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_CorporateFareIcon),
              _hoisted_6
            ]),
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.siteProfile.name), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_FmdGood),
              _hoisted_10
            ]),
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.siteProfile.country_name), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_CloudDone),
              _hoisted_14
            ]),
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.siteProfile.data_storage_name), 1)
          ]),
          (_ctx.formatAddress(_ctx.siteProfile))
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode(_component_FmdGood),
                  _hoisted_18
                ]),
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.formatAddress(_ctx.siteProfile)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.siteProfile.web_site)
            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode(_component_Computer),
                  _hoisted_22
                ]),
                _createVNode("div", _hoisted_23, [
                  _createVNode("a", {
                    href: _ctx.siteProfile.web_site,
                    target: "_blank"
                  }, _toDisplayString(_ctx.siteProfile.web_site), 9, ["href"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.siteProfile.comment)
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode(_component_Comment),
                  _hoisted_26
                ]),
                _createVNode("div", _hoisted_27, _toDisplayString(_ctx.siteProfile.comment), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}